import styled from '@emotion/styled'

export const MapContainer = styled.div`
  height: 320px;
  width: 100%;
  margin-bottom: 30px;
`

export const Container = styled.div`
  margin: 40px 0;
`

export const StyledText = styled.p`
  color: #3e3f42;
  font-size: 16px;
`

export const DriverInstructionsContainer = styled.div`
  padding-bottom: 40px;
`
